import { ParsedUrlQuery } from 'querystring';

export function getNewHomes(query: ParsedUrlQuery, pathname: string) {
    if (query['new_homes']) {
        return query['new_homes'];
    }

    if (pathname?.includes && pathname?.includes('/new-homes/')) {
        return 'only';
    }

    return 'include';
}
